import { CheckOutcome } from '@percent/admin-dashboard/api/types'
import { BadgeProps } from '@percent/lemonade'

export const getOutcomeBadgeAppearance = (
  outcome: CheckOutcome | null | undefined
): Pick<BadgeProps, 'variant' | 'icon'> => {
  if (outcome === 'accepted') return { variant: 'positive', icon: 'check-badge' }

  if (outcome === 'rejected') return { variant: 'critical', icon: 'warning' }

  return { variant: 'default', icon: 'info' }
}
